import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "confirmationInput", "passwordInput", "submitButton", "errorMessage", "form"]
  static values = {
    email: String
  }

  connect() {
    this.confirmationText = "DELETE"
  }

  showModal(event) {
    event.preventDefault()
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove("hidden")
      this.resetForm()
    }
  }

  hideModal(event) {
    event.preventDefault()
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("hidden")
      this.resetForm()
    }
  }

  validateConfirmation() {
    const confirmationValid = this.confirmationInputTarget.value === this.confirmationText
    const passwordValid = this.passwordInputTarget.value.length > 0

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !(confirmationValid && passwordValid)
    }
  }

  async submitDeletion(event) {
    event.preventDefault()

    const confirmation = confirm("This is your final warning. Are you absolutely sure you want to permanently delete your account?")

    if (!confirmation) {
      return false
    }

    this.setLoadingState(true)
    this.hideError()

    const password = this.passwordInputTarget.value

    try {
      const response = await fetch('/users/validate_password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ current_password: password })
      })

      const data = await response.json()

      if (response.ok && data.valid) {
        this.submitButtonTarget.textContent = "Deleting Account..."
        this.formTarget.submit()
      } else {
        this.showError(data.error || 'Invalid password. Please try again.')
        this.setLoadingState(false)
      }
    } catch (error) {
      this.showError('An error occurred. Please try again.')
      this.setLoadingState(false)
    }
  }

  setLoadingState(loading) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = loading
      if (loading) {
        this.submitButtonTarget.textContent = "Confirming Password..."
      } else {
        this.submitButtonTarget.textContent = "Permanently Delete Account"
      }
    }
  }

  showError(message) {
    if (this.hasErrorMessageTarget) {
      const textElement = this.errorMessageTarget.querySelector('p')
      if (textElement) {
        textElement.textContent = message
      }
      this.errorMessageTarget.classList.remove("hidden")
    }
  }

  hideError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.add("hidden")
    }
  }

  resetForm() {
    if (this.hasConfirmationInputTarget) {
      this.confirmationInputTarget.value = ""
    }
    if (this.hasPasswordInputTarget) {
      this.passwordInputTarget.value = ""
    }
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.textContent = "Permanently Delete Account"
    }
    this.hideError()
  }
}
